import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Popover from 'react-bootstrap/lib/Popover';
import clickOutside from 'react-click-outside';

class TooltipPopover extends Component {
  constructor (props) {
    super(props);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  handleClickOutside (e) {
    const ignoreClickOutside = $(e.target).hasClass('ignore-clickoutside');
    if ($(e.target).hasClass('icon-question')) {
      return;
    }
    if (!ignoreClickOutside) {
      this.props.toggle();
    }
  }

  render () {
    const { content, settings, children, popoverClassName } = this.props;
    return (
      <Popover
        id="tooltip-popover"
        className={`popover ${popoverClassName}`}
        {...settings}
      >
        <div>{content || children}</div>
      </Popover>
    );
  }
}

TooltipPopover.propTypes = {
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  settings: PropTypes.object,
  toggle: PropTypes.func
};

export default clickOutside(TooltipPopover);
